module.exports = __webpack_public_path__ + "static/OP0-6520fdf43dc5f7321afe66e8db3d8db4.jpg";